module.exports = __webpack_public_path__ + "static/sandhaan-labs-2.4.0-87c958f5afe6960991c053d93919a6b7.png";